import claddingCharcoalImg from "@/assets/products/wpc-cladding-charcoal.jpg";
import claddingRedwoodImg from "@/assets/products/wpc-cladding-redwood.jpg";
import claddingTeakImg from "@/assets/products/wpc-cladding-teak.jpg";
import claddingLightTeakImg from "@/assets/products/wpc-cladding-light-teak.jpg";
import claddingGreyImg from "@/assets/products/wpc-cladding-grey.jpg";
import claddingAntiqueImg from "@/assets/products/wpc-cladding-antique.jpg";
import claddingAntiqueLife1 from "@/assets/products/wpc-cladding-antique-lifestyle-1.jpg";
import claddingAntiqueLife2 from "@/assets/products/wpc-cladding-antique-lifestyle-2.jpg";
import claddingAntiqueLife3 from "@/assets/products/wpc-cladding-antique-lifestyle-3.jpg";
import claddingAntiqueLife4 from "@/assets/products/wpc-cladding-antique-lifestyle-4.jpg";
import claddingWhiteImg from "@/assets/products/wpc-cladding-white.jpg";
import indoorBlackImg from "@/assets/products/indoor-cladding-black.jpg";
import indoorOakImg from "@/assets/products/indoor-cladding-oak.jpg";
import indoorCharcoalImg from "@/assets/products/indoor-cladding-charcoal.jpg";
import indoorWalnutImg from "@/assets/products/indoor-cladding-walnut.jpg";
import lTrimImg from "@/assets/products/cladding-l-trim.png";
import exteriorCornerImg from "@/assets/products/cladding-exterior-corner.png";
import blackbuttPanel from "@/assets/products/brushed-blackbutt-panel.webp.asset.json";
import blackbuttInstalled from "@/assets/products/brushed-blackbutt-installed.webp.asset.json";
import blackbuttDetail from "@/assets/products/brushed-blackbutt-detail.webp.asset.json";

export interface CladdingSizeOption {
  length: string;
  price: number;
  /** Shopify variant ID when available; otherwise a distinct local order-request ID. */
  variantId: string;
}

export interface CladdingProduct {
  id: string;
  name: string;
  colour: string;
  image: string;
  gallery?: string[];
  description: string;
  width: string;
  thickness: string;
  coveredWidth?: string;
  sizes: CladdingSizeOption[];
  features: string[];
  useCases: string[];
  qldOnly?: boolean;
}

export interface CladdingAccessory {
  id: string;
  name: string;
  price: number;
  unit: string;
  size: string;
  image: string;
  description: string;
  specs: string[];
  shopifyVariantId?: string;
}

// Shopify Product IDs created 2026-02-20
// EXT Charcoal: 9482470359281 | Redwood: 9482470424817 | Teak: 9482470457585
// Light Teak: 9482470490353 | Grey: 9482470523121 | Antique: 9482470588657 | White: 9482470654193
// IND Black: 9482470719729 | Oak: 9482470785265 | Charcoal: 9482470818033 | Walnut: 9482470850801

export const EXTERNAL_CLADDING_PRODUCTS: CladdingProduct[] = [
  {
    id: "ext-cladding-brushed-blackbutt",
    name: "Brushed Blackbutt External Cladding",
    colour: "Brushed Blackbutt",
    image: blackbuttPanel.url,
    gallery: [blackbuttPanel.url, blackbuttDetail.url, blackbuttInstalled.url],
    description: "Brushed Blackbutt external cladding panels with a timber-look finish. Each panel is 219mm wide with 200mm covered width, available in 2m and 2.9m lengths.",
    width: "219mm",
    coveredWidth: "200mm",
    thickness: "",
    sizes: [
      { length: "2m", price: 28, variantId: "local-ext-cladding-brushed-blackbutt-2m" },
      { length: "2.9m", price: 40, variantId: "local-ext-cladding-brushed-blackbutt-2-9m" },
    ],
    features: ["Brushed Blackbutt finish", "200mm covered width", "Two panel lengths"],
    useCases: ["Exterior feature walls", "Façades", "Outdoor wall cladding"],
  },
  {
    id: "ext-cladding-charcoal",
    name: "Charcoal External Cladding",
    colour: "Charcoal",
    image: claddingCharcoalImg,
    description: "Durable and high-performance WPC external cladding, suitable for both residential and trade projects.",
    width: "219mm",
    thickness: "26mm",
    sizes: [
      { length: "1.8m", price: 22, variantId: "gid://shopify/ProductVariant/47816723136753" },
      { length: "2m",   price: 25, variantId: "gid://shopify/ProductVariant/47816723169521" },
      { length: "2.4m", price: 29, variantId: "gid://shopify/ProductVariant/47816723202289" },
      { length: "2.9m", price: 35, variantId: "gid://shopify/ProductVariant/47816723235057" },
      { length: "3.6m", price: 45, variantId: "gid://shopify/ProductVariant/47816723267825" },
    ],
    features: ["Waterproof", "UV Protected", "Scratch Resistant", "Termite Proof", "Paintable"],
    useCases: ["Outdoor walls", "Fences", "Façades", "Garage doors", "Garden beds"],
  },
  {
    id: "ext-cladding-redwood",
    name: "Redwood External Cladding",
    colour: "Redwood",
    image: claddingRedwoodImg,
    description: "Ideal for a natural wood look with added durability. No priming or sanding needed.",
    width: "219mm",
    thickness: "26mm",
    sizes: [
      { length: "1.8m", price: 22, variantId: "gid://shopify/ProductVariant/47816723366129" },
      { length: "2m",   price: 25, variantId: "gid://shopify/ProductVariant/47816723398897" },
      { length: "2.4m", price: 29, variantId: "gid://shopify/ProductVariant/47816723431665" },
      { length: "2.9m", price: 35, variantId: "gid://shopify/ProductVariant/47816723464433" },
      { length: "3.6m", price: 45, variantId: "gid://shopify/ProductVariant/47816723497201" },
    ],
    features: ["Waterproof", "UV Protected", "Natural Wood Look", "Termite Proof", "Low Maintenance"],
    useCases: ["Outdoor walls", "Fences", "Patios", "Façades", "Ceilings"],
  },
  {
    id: "ext-cladding-teak",
    name: "Teak External Cladding",
    colour: "Teak",
    image: claddingTeakImg,
    description: "Elegant teak finish for stylish exterior facades. Zero maintenance required.",
    width: "219mm",
    thickness: "26mm",
    sizes: [
      { length: "1.8m", price: 22, variantId: "gid://shopify/ProductVariant/47816723595505" },
      { length: "2m",   price: 25, variantId: "gid://shopify/ProductVariant/47816723628273" },
      { length: "2.4m", price: 29, variantId: "gid://shopify/ProductVariant/47816723661041" },
      { length: "2.9m", price: 35, variantId: "gid://shopify/ProductVariant/47816723693809" },
      { length: "3.6m", price: 45, variantId: "gid://shopify/ProductVariant/47816723726577" },
    ],
    features: ["Waterproof", "UV Protected", "Classic Teak Finish", "Termite Proof", "Paintable"],
    useCases: ["Façades", "Outdoor walls", "Doors", "Ceilings", "Garden beds"],
  },
  {
    id: "ext-cladding-light-teak",
    name: "Light Teak External Cladding",
    colour: "Light Teak",
    image: claddingLightTeakImg,
    description: "Lighter teak finish for more subtle designs. Best alternative to real timber.",
    width: "219mm",
    thickness: "26mm",
    sizes: [
      { length: "1.8m", price: 22, variantId: "gid://shopify/ProductVariant/47816723759345" },
      { length: "2m",   price: 25, variantId: "gid://shopify/ProductVariant/47816723792113" },
      { length: "2.4m", price: 29, variantId: "gid://shopify/ProductVariant/47816723824881" },
      { length: "2.9m", price: 35, variantId: "gid://shopify/ProductVariant/47816723857649" },
    ],
    features: ["Waterproof", "UV Protected", "Subtle Finish", "No Priming Needed", "Versatile"],
    useCases: ["Outdoor walls", "Fences", "Patios", "Indoor walls"],
  },
  {
    id: "ext-cladding-grey",
    name: "Grey External Cladding",
    colour: "Grey",
    image: claddingGreyImg,
    description: "A sleek grey finish suitable for modern exteriors. Superior weather resistance.",
    width: "219mm",
    thickness: "26mm",
    sizes: [
      { length: "1.8m", price: 22, variantId: "gid://shopify/ProductVariant/47816723890417" },
      { length: "2m",   price: 25, variantId: "gid://shopify/ProductVariant/47816723923185" },
      { length: "2.4m", price: 29, variantId: "gid://shopify/ProductVariant/47816723955953" },
      { length: "2.9m", price: 35, variantId: "gid://shopify/ProductVariant/47816723988721" },
    ],
    features: ["Waterproof", "UV Protected", "Modern Finish", "Scratch Resistant", "Termite Proof"],
    useCases: ["Modern façades", "Outdoor walls", "Fences", "Commercial exteriors"],
  },
  {
    id: "ext-cladding-antique",
    name: "Antique External Cladding",
    colour: "Antique",
    image: claddingAntiqueImg,
    gallery: [claddingAntiqueImg, claddingAntiqueLife1, claddingAntiqueLife2, claddingAntiqueLife3, claddingAntiqueLife4],
    description: "Weathered look with superior UV resistance. Adds character to any exterior.",
    width: "219mm",
    thickness: "26mm",
    sizes: [
      { length: "1.8m", price: 22, variantId: "gid://shopify/ProductVariant/47816724054257" },
      { length: "2m",   price: 25, variantId: "gid://shopify/ProductVariant/47816724087025" },
      { length: "2.4m", price: 29, variantId: "gid://shopify/ProductVariant/47816724119793" },
      { length: "2.9m", price: 35, variantId: "gid://shopify/ProductVariant/47816724152561" },
    ],
    features: ["Waterproof", "UV Protected", "Weathered Look", "Fade Resistant", "Paintable"],
    useCases: ["Feature walls", "Fences", "Outdoor living areas", "Garden beds"],
  },
  {
    id: "ext-cladding-white",
    name: "White External Cladding",
    colour: "White",
    image: claddingWhiteImg,
    description: "White exterior cladding with excellent resistance to the elements.",
    width: "219mm",
    thickness: "26mm",
    sizes: [
      { length: "1.8m", price: 22, variantId: "gid://shopify/ProductVariant/47816724545777" },
      { length: "2m",   price: 25, variantId: "gid://shopify/ProductVariant/47816724578545" },
      { length: "2.4m", price: 29, variantId: "gid://shopify/ProductVariant/47816724611313" },
      { length: "2.9m", price: 35, variantId: "gid://shopify/ProductVariant/47816724644081" },
    ],
    features: ["Waterproof", "UV Protected", "White Finish", "Termite Proof", "Clean Finish"],
    useCases: ["Coastal homes", "Modern façades", "Outdoor walls", "Ceilings"],
  },
];

export const INDOOR_CLADDING_PRODUCTS: CladdingProduct[] = [
  {
    id: "indoor-cladding-black",
    name: "Black Indoor Cladding",
    colour: "Black",
    image: indoorBlackImg,
    description: "Sleek black WPC indoor cladding for modern accent walls. Easy clip-on installation.",
    width: "150mm",
    thickness: "12mm",
    sizes: [
      { length: "1.8m", price: 18, variantId: "gid://shopify/ProductVariant/47816724742385" },
      { length: "2m",   price: 20, variantId: "gid://shopify/ProductVariant/47816724775153" },
      { length: "2.4m", price: 24, variantId: "gid://shopify/ProductVariant/47816724807921" },
      { length: "2.9m", price: 29, variantId: "gid://shopify/ProductVariant/47816724840689" },
    ],
    features: ["Moisture Resistant", "Easy Install", "Sleek Finish", "Lightweight", "No Painting Needed"],
    useCases: ["Accent walls", "Feature walls", "Ceilings", "Bedrooms"],
  },
  {
    id: "indoor-cladding-oak",
    name: "Oak Indoor Cladding",
    colour: "Oak",
    image: indoorOakImg,
    description: "Light oak WPC indoor wall panels. Creates a warm, Scandinavian-inspired interior.",
    width: "150mm",
    thickness: "12mm",
    sizes: [
      { length: "1.8m", price: 18, variantId: "gid://shopify/ProductVariant/47816724938993" },
      { length: "2m",   price: 20, variantId: "gid://shopify/ProductVariant/47816724971761" },
      { length: "2.4m", price: 24, variantId: "gid://shopify/ProductVariant/47816725004529" },
      { length: "2.9m", price: 29, variantId: "gid://shopify/ProductVariant/47816725037297" },
    ],
    features: ["Moisture Resistant", "Easy Install", "Natural Oak Look", "Lightweight", "Low Maintenance"],
    useCases: ["Living rooms", "Bedrooms", "Hallways", "Ceilings"],
  },
  {
    id: "indoor-cladding-charcoal",
    name: "Charcoal Indoor Cladding",
    colour: "Charcoal",
    image: indoorCharcoalImg,
    description: "Charcoal WPC indoor cladding for contemporary accent walls and feature spaces.",
    width: "150mm",
    thickness: "12mm",
    sizes: [
      { length: "1.8m", price: 18, variantId: "gid://shopify/ProductVariant/47816725070065" },
      { length: "2m",   price: 20, variantId: "gid://shopify/ProductVariant/47816725102833" },
      { length: "2.4m", price: 24, variantId: "gid://shopify/ProductVariant/47816725135601" },
      { length: "2.9m", price: 29, variantId: "gid://shopify/ProductVariant/47816725168369" },
    ],
    features: ["Moisture Resistant", "Easy Install", "Modern Look", "Low Maintenance", "Lightweight"],
    useCases: ["Accent walls", "Offices", "Commercial interiors", "Ceilings"],
  },
  {
    id: "indoor-cladding-walnut",
    name: "Walnut Indoor Cladding",
    colour: "Walnut",
    image: indoorWalnutImg,
    description: "Rich walnut WPC indoor wall panels. Adds warmth and luxury to any interior space.",
    width: "150mm",
    thickness: "12mm",
    sizes: [
      { length: "1.8m", price: 18, variantId: "gid://shopify/ProductVariant/47816725233905" },
      { length: "2m",   price: 20, variantId: "gid://shopify/ProductVariant/47816725266673" },
      { length: "2.4m", price: 24, variantId: "gid://shopify/ProductVariant/47816725299441" },
      { length: "2.9m", price: 29, variantId: "gid://shopify/ProductVariant/47816725332209" },
    ],
    features: ["Moisture Resistant", "Easy Install", "Walnut Finish", "Lightweight", "Elegant Look"],
    useCases: ["Living rooms", "Dining rooms", "Feature walls", "Bedrooms"],
  },
];

export const CLADDING_ACCESSORIES: CladdingAccessory[] = [
  {
    id: "cladding-l-trim",
    name: "L-Shape Trim",
    price: 15,
    unit: "each",
    size: "60mm × 40mm × 2.9m",
    image: lTrimImg,
    description: "End cap / L-shape trim for clean edge finishing on WPC cladding installations. Model JE101.",
    specs: ["WPC material", "Colour-matched options", "60mm × 40mm × 2.9m", "Model: JE101"],
    shopifyVariantId: "gid://shopify/ProductVariant/47826820628721",
  },
  {
    id: "cladding-exterior-corner",
    name: "Exterior Corner",
    price: 25,
    unit: "each",
    size: "49.5mm × 49.5mm × 2.9m",
    image: exteriorCornerImg,
    description: "Exterior corner trim for seamless WPC cladding outside corner transitions. Model JE104.",
    specs: ["WPC material", "Colour-matched options", "49.5mm × 49.5mm × 2.9m", "Model: JE104"],
    shopifyVariantId: "gid://shopify/ProductVariant/47826820661489",
  },
];

/** Adelaide (SA) does not stock 1.8m external cladding lengths. */
export function localizeCladdingProduct(product: CladdingProduct, state: string | null | undefined): CladdingProduct {
  if (state !== "SA" || !EXTERNAL_CLADDING_PRODUCTS.some(p => p.id === product.id)) return product;
  const sizes = product.sizes.filter(s => s.length !== "1.8m");
  return sizes.length ? { ...product, sizes } : product;
}
